@let sequence = this.sequence();

<div
  class="border-stroke-neutral-light px-md py-sm gap-1 rounded-lg border bg-white"
  [class.ring-stroke-primary-main]="isSelected()"
  [class.ring-2]="isSelected()"
  [id]="sequence.id"
>
  <div class="flex justify-between">
    <div class="flex flex-col gap-2">
      <span class="paragraph-large-semibold">{{ sequence.nom }}</span>
      @if (isExpanded()) {
        <div class="text-grey-8 flex flex-col gap-1">
          <div class="flex gap-1">
            <span class="paragraph-medium-semibold">Code : </span>
            <p class="paragraph-medium-medium flex-1">{{ sequence.codeSequence }}</p>
          </div>
          <div class="flex gap-1">
            <span class="paragraph-medium-semibold">Durée : </span>
            <p class="paragraph-medium-medium flex-1">{{ sequence.duree }}h</p>
          </div>
          <div class="flex gap-1">
            <span class="paragraph-medium-semibold">Type : </span>
            <p class="paragraph-medium-medium flex-1">{{ sequence.type }}</p>
          </div>
        </div>
      }
    </div>
    @if (isExpanded()) {
      <ng-content />
    }
  </div>
  @if (isExpanded()) {
    <div class="mt-xs flex justify-between">
      <div class="text-grey-8 flex items-center gap-1">
        <ng-icon hlm size="xs" name="lucideNotebookText" />
        <span>{{ sequence.activites?.length ?? 0 }} activités liées</span>
      </div>
      <app-sequence-etat [etat]="sequence.etat" />
    </div>
  }
</div>
